import { CONFIG } from 'utils/config';
import { getReturnUrl } from 'helpers';
import { getWebAppLink } from '@landr/core';

export const usePricingConfig = (): {
    authenticatedPricingPath: string;
    guestPricingPath: string;
} => {
    const authenticatedPricingPath = `${getWebAppLink(
        CONFIG.VITE_APP_ENV,
        '/pricing/samples',
    )}?returnUrl=${getReturnUrl()}`;

    const guestPricingPath = `${CONFIG.VITE_GUEST_PRICING_URL}/samples-en`;

    return {
        authenticatedPricingPath,
        guestPricingPath,
    };
};
